import { render, staticRenderFns } from "./CoreUsers.vue?vue&type=template&id=3b44b1bc&scoped=true&"
import script from "./CoreUsers.vue?vue&type=script&lang=js&"
export * from "./CoreUsers.vue?vue&type=script&lang=js&"
import style0 from "./CoreUsers.vue?vue&type=style&index=0&id=3b44b1bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b44b1bc",
  null
  
)

export default component.exports